<template>
  <v-btn
    :class="
      textConfigs
        ? textConfigs.label
        : 'font-weight-bold text-h6 mb-1 px-2 text-capitalize unfade'
    "
    plain
    :color="colorAccent ? colorAccent : ''"
    text
    x-large
    @click="$emit(`${method}`)"
    :disabled="disabled"
  >
    {{ buttonText }}
  </v-btn>
</template>

<script>
export default {
  name: "PlainButton",
  props: {
    buttonText: {
      type: String,
      required: true,
      default: "",
    },
    colorAccent: {
      type: String,
      required: false,
    },
    method: {
      type: String,
      required: false,
    },
    textConfigs: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
};
</script>
